import "./StockbridgeServiceArea.module.css";
import Header from "@/reusable_sections/Header";
import Stockbridge from "./sections/Stockbridge";
import StockbridgeServiceArea from "./sections/StockbridgeServiceArea";
import ServicesGrid from "./sections/ServicesGrid";
import StockbridgeIssues from "./sections/StockbridgeIssues";
import FaqAccordion from "./sections/FaqAccordion";
import StockbridgeCTA from "./sections/StockbridgeCTA";
import Footer from "@/reusable_sections/Footer";
export default function StockbridgeServiceAreaPage() {
  return <div>
      <Header />
      <Stockbridge />
      <StockbridgeServiceArea />
      <ServicesGrid />
      <StockbridgeIssues />
      <FaqAccordion />
      <StockbridgeCTA />
      <Footer />
    </div>;
}